import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ContactModel from "../../models/contact";

export default class EntityContactRepository extends BaseRepository {
  static modelClass = ContactModel;
  modelName = "contact";

  normalizeRelationType(relationType) {
    if (typeof relationType !== "string") {
      return relationType;
    }

    return relationType.replace(/^"+|"+$/g, "");
  }

  async query(entityId, params = {}) {
    return await super.query({
      urlPath: `entities/${entityId}/contacts/?${qs.stringify(params)}`,
    });
  }

  async patch(entityId, data) {
    return await super.patch(data.id, data, {
      urlPath: `entities/${entityId}/contacts/${data.id}`,
    });
  }

  async createRecord(entityId, data) {
    const relation_type = this.normalizeRelationType(data.relationType);
    const payload = { ...data };

    if ("relationType" in payload) {
      delete payload.relationType;
    }

    const basePath = `entities/${entityId}/contacts/`;
    const queryString = qs.stringify({ relation_type });
    const urlPathWithQueryParams = `${basePath}?${queryString}`;

    return await super.createRecord(payload, { urlPathWithQueryParams });
  }

  async delete(entityId, contactId) {
    return await super.delete(contactId, {
      urlPath: `entities/${entityId}/contacts`,
    });
  }
}
